import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PuneForm } from "@/components/PuneForm";

export default function JepPunePage() {
  const nav = useNavigate();
  const { user, setAuthOpen } = useAuth();
  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për të publikuar një punë.</div>;
  return <PuneForm onDone={(id) => nav(`/shpallje/${id}`)} />;
}
